const navigationCz = {
    "menu_editor": "Menu",
    "settings": "Nastavení",
    "payment_settings": "Nastavení plateb",
    "user_management": "Správa uživatelů",
    "logout": "Odhlásit se",
    "subscription": "Předplatné",
    "new_restaurant": "Vytvořit novou restauraci",
    "privacy_policy": "Zásady ochrany osobních údajů",
    "terms_and_conditions": "Obchodní podmínky",
    "statistics": "Statistika",
    "mozrest": "Manažer recenzí",
    "signup": "Registrovat se"
};

export default navigationCz;
